<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Privilege</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="information-group pb-5">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Privilege Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col">
              <BrandDropdown
                v-model="brandSelected"
                :setDisable="!!this.$route.query.id"
                @setBrand="setBrand"
                @setBrands="setBrands"
              ></BrandDropdown>
              <div v-if="isSubmit && error.errorBrand" class="text-error">
                {{ error.errorBrand.message }}
              </div>
              <div v-if="isSubmit && error.errorBrandCode" class="text-error">
                {{ error.errorBrandCode.message }}
              </div>
            </div>
            <div class="col">
              <label for="selectedVoucher"
                >Voucher type (Membership/Yearend/Catalog)</label
              >
              <multiselect
                id="selectedVoucher"
                v-model="form.voucherSelected"
                :options="voucherOptions"
                label="text"
                track-by="code"
                :disabled="!!this.$route.query.id"
                @input="changeVoucherType"
              >
              </multiselect>
              <div v-if="isSubmit && error.errorType" class="text-error">
                {{ error.errorType.message }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-6" v-show="isFieldShown('pickupStores')">
              <div class="d-flex flex-row">
                <div class="mr-auto">Pickup stores</div>
                <input
                  id="isAnyStores"
                  class="form-check-input mr-2"
                  type="checkbox"
                  v-model="form.isAnyStore"
                />
                <label class="form-check-label" for="isAnyStores">
                  Any stores
                </label>
                <div
                  v-if="isSubmit && error.errorIsAnyStore"
                  class="text-error"
                >
                  {{ error.errorIsAnyStore.message }}
                </div>
              </div>
              <div :dir="rtl ? 'rtl' : 'ltr'">
                <treeselect
                  name="demo"
                  :multiple="multiple"
                  :clearable="clearable"
                  :searchable="searchable"
                  :disabled="disabled"
                  :open-on-click="openOnClick"
                  :open-on-focus="openOnFocus"
                  :clear-on-select="clearOnSelect"
                  :close-on-select="closeOnSelect"
                  :always-open="alwaysOpen"
                  :append-to-body="appendToBody"
                  :options="storeOptions"
                  :limit="10"
                  :value-consists-of="'LEAF_PRIORITY'"
                  :max-height="200"
                  v-model="form.pickupStores"
                />
                <div
                  v-if="isSubmit && error.errorPickupStores"
                  class="text-error"
                >
                  {{ error.errorPickupStores.message }}
                </div>
              </div>
            </div>
            <div class="col col-4" v-show="isFieldShown('yearendSelected')">
              <label for="selectedYearend"
                >Year end premium year (for yearend)</label
              >
              <multiselect
                id="selectedYearend"
                v-model="form.yearendSelected"
                :options="yearendOptions"
                label="text"
                track-by="text"
              >
              </multiselect>
              <div v-if="isSubmit && error.errorPointYear" class="text-error">
                {{ error.errorPointYear.message }}
              </div>
            </div>
            <div class="col col-2" v-show="isFieldShown('isAllowDelivery')">
              <div class="d-flex flex-row justify-content-center pt-8">
                <input
                  class="form-check-input mr-2"
                  id="isAllowDelivery"
                  type="checkbox"
                  v-model="form.isAllowDelivery"
                />
                <label class="form-check-label" for="isAllowDelivery">
                  Delivery
                </label>
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('redeem')">
            <div class="col">
              <label for="redemptionStartDate" required
                >Redemption start date</label
              >
              <DatePicker
                id="redemptionStartDate"
                v-bind="$attrs"
                v-model="form.redeemStartDate"
                format="D MMMM yyyy"
                lang="en"
                :value="form.redeemStartDate"
                @change="
                  changeStartDate($event);
                  form.redeemStartDate = $event;
                "
                style="margin-top: -0.6rem"
              />
              <div
                v-if="isSubmit && error.errorRedeemStartDate"
                class="text-error"
              >
                {{ error.errorRedeemStartDate.message }}
              </div>
            </div>
            <div class="col">
              <label for="redemptionEndDate" required
                >Redemption end date</label
              >
              <DatePicker
                id="redemptionEndDate"
                v-bind="$attrs"
                v-model="form.redeemEndDate"
                format="D MMMM yyyy"
                lang="en"
                :value="form.redeemEndDate"
                :minDate="form.redeemStartDate"
                @change="form.redeemEndDate = $event"
                style="margin-top: -0.6rem"
              />
              <div
                v-if="isSubmit && error.errorRedeemEndDate"
                class="text-error"
              >
                {{ error.errorRedeemEndDate.message }}
              </div>
            </div>
            <div class="col">
              <label for="redeemLimit">Redeem limit (per customer)</label>
              <NumberInput v-model.number="form.limit" input-id="redeemLimit"
              />
              <div v-if="isSubmit && error.errorLimit" class="text-error">
                {{ error.errorLimit.message }}
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('voucherTypeCode')">
            <div class="col-6">
              <label for="voucherTypeCode">Cegid voucher type code</label>
              <input
                id="voucherTypeCode"
                type="text"
                v-model="form.voucherTypeCode"
                class="form-control"
              />
            </div>
          </div>
          <div class="row" v-show="isFieldShown('point')">
            <div class="col-6">
              <label for="point">Point</label>
              <NumberInput
                v-model.number="form.point"
                input-id="point"
                :disabled="!!this.$route.query.id"
                :is-decimal-allowed="true"/>
              <div v-if="isSubmit && error.errorPoint" class="text-error">
                {{ error.errorPoint.message }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div>Status</div>
              <div class="d-flex flex-row">
                <input
                  class="form-check-input mr-2"
                  id="isActive"
                  type="checkbox"
                  v-model="form.status"
                />
                <label class="form-check-label" for="isActive"> Active </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-8" v-if="accessLink">
              <div>Link to access sample product on Beauty Connect</div>
              <div class="accessLink d-flex gap-2">
                <div class="pt-1">
                  {{ accessLink }}
                </div>
                <button @click="copyLink">
                  <font-awesome-icon :icon="['fas', 'copy']" id="copyLink" />
                </button>
              </div>
              <b-tooltip
                target="copyLink"
                triggers="hover"
                placement="bottom"
                variant="dark"
                >{{ copyText }}
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div
        class="information-group pb-5 mt-8"
        v-if="form.voucherSelected && form.voucherSelected.code === 'CATALOG'"
      >
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Spending Condition</div>
        </div>
        <div class="px-6 py-3">
          <TopSpenderCampaignSection
            :form="form"
            :is-submit="isSubmit"
            :error="error"
            :preview-campaign-banner-url="previewCampaignBannerUrl"
            :upload-campaign-banner="uploadCampaignBanner"
            :is-disabled="!!$route.query.id"
          />
        </div>
      </div>
      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Product Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col-3">
              <input
                class="form-check-input mr-2"
                type="radio"
                name="productType"
                id="single"
                :value="ProductTypeOption.SingleProduct"
                v-model="form.productType"
              />
              <label class="form-check-label" for="single"
                >Single product</label
              >
              <div v-if="isSubmit && error.errorProductType" class="text-error">
                {{ error.errorProductType.message }}
              </div>
            </div>
            <div class="col-3" v-show="isFieldShown('productVariances')">
              <input
                class="form-check-input mr-2"
                type="radio"
                name="productType"
                id="variance"
                :value="ProductTypeOption.ProductVariance"
                v-model="form.productType"
              />
              <label class="form-check-label" for="variance"
                >Product variances</label
              >
            </div>
            <div class="col-3" v-show="isFieldShown('bundle')">
              <input
                class="form-check-input mr-2"
                type="radio"
                name="productType"
                id="bundle"
                :value="ProductTypeOption.ProductBundle"
                v-model="form.productType"
              />
              <label class="form-check-label" for="bundle">Bundle</label>
            </div>
          </div>
          <div
            v-if="form.productType === ProductTypeOption.ProductVariance"
            class="row"
          >
            <div class="col-4">
              <label for="varianceNameTh">Variance name TH</label>
              <input
                id="varianceNameTh"
                class="form-control"
                type="text"
                v-model="varianceNameTh"
              />
            </div>
            <div class="col">
              <label for="varianceNameEn">Variance name EN</label>
              <input
                id="varianceNameEn"
                class="form-control"
                style="width: 48%"
                type="text"
                v-model="varianceNameEn"
              />
            </div>
          </div>
          <div
            v-if="form.productType === ProductTypeOption.ProductBundle"
            class="row"
          >
            <div class="col-4">
              <label for="selectedSubBundle">Sub bundle privilege</label>
              <multiselect
                id="selectedSubBundle"
                v-model="subBundleSelected"
                :options="subBundleOptions"
                label="text"
                track-by="id"
              />
              <div
                v-if="isSubBundleAdded && duplicateSubBundleMessage != null"
                class="text-error"
              >
                {{ duplicateSubBundleMessage }}
              </div>
            </div>
            <div class="col-4">
              <label for="subBundleQuantity">Quantity</label>
              <NumberInput v-model.number="subBundleQuantity" input-id="subBundleQuantity"
              />
            </div>
            <div class="col-4 d-flex align-center mt-8">
              <button
                class="btn btn-outline-success w-50 btn-add-variance"
                :disabled="!subBundleSelected || subBundleQuantity <= 0"
                @click="addSubBundle"
              >
                Add
              </button>
            </div>
          </div>
          <ListSelectedSubBundles
            v-if="
              listSelectedSubBundles.length > 0 &&
              form.productType === ProductTypeOption.ProductBundle
            "
            :items="listSelectedSubBundles"
            @deleteSubBundle="deleteSubBundle"
          />
          <div class="row">
            <div
              class="col-4"
              v-show="form.productType !== ProductTypeOption.ProductBundle"
            >
              <label for="selectedProductVariance">Product</label>
              <multiselect
                id="selectedProductVariance"
                v-model="productVarianceSelected"
                :options="productOptions"
                label="fullText"
                track-by="id"
              />
              <div v-if="isSubmit && error.errorParentCode" class="text-error">
                {{ error.errorParentCode.message }}
              </div>
              <div
                v-if="
                  isProductVarianceAdded &&
                  duplicateProductVarianceMessage != null
                "
                class="text-error"
              >
                {{ duplicateProductVarianceMessage }}
              </div>
            </div>
            <div class="col-4" v-show="isFieldShown('quota')">
              <label for="quota">Quota</label>
              <NumberInput v-model.number="productQuota" input-id="quota" :custom-style="{ marginTop: '3px' }"
              />
              <div v-if="isSubmit && error.errorQuota" class="text-error">
                {{ error.errorQuota.message }}
              </div>
            </div>
            <div
              v-if="form.productType === ProductTypeOption.ProductVariance"
              class="col-4 d-flex align-center mt-8"
            >
              <button
                class="btn btn-outline-success w-50 btn-add-variance"
                :disabled="
                  !varianceNameTh ||
                  !varianceNameEn ||
                  !productVarianceSelected ||
                  productQuota <= 0
                "
                @click="addProductVariance"
              >
                Add
              </button>
            </div>
          </div>
          <ListProductVariances
            v-if="
              listProductVariances.length > 0 &&
              form.productType === ProductTypeOption.ProductVariance
            "
            :items="listProductVariances"
            @deleteProductVariance="deleteProductVariance"
          />
          <div class="row mt-2" v-show="isFieldShown('totalQuota') && id">
            <div class="col-4">
              <label for="totalQuota">Total quota</label>
              <NumberInput v-model.number="form.quota" input-id="totalQuota"
                           disabled="disabled" :custom-style="{marginTop: '3px'}"/>

            </div>
          </div>
        </div>
      </div>

      <div
        class="information-group pb-5 mt-8"
        v-if="
          isServiceReservationEnabled &&
          (form.productType === ProductTypeOption.SingleProduct ||  form.productType === ProductTypeOption.ProductVariance)
        "
      >
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Service Reservation</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <div class="col-4">
              <div class="d-flex flex-row">
                <input
                  class="form-check-input mr-2"
                  id="isBooking"
                  type="checkbox"
                  v-model="form.booking"
                />
                <label class="form-check-label" for="isBooking">
                  Service reservation
                </label>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 0" v-show="form.booking">
            <div class="col-4">
              <label for="serviceSelection">Service</label>
              <multiselect
                id="serviceSelection"
                v-model="serviceSelected"
                :options="serviceOptions"
                label="text"
                track-by="id"
              />
              <div v-if="isSubmit && error.errorService" class="text-error">
                {{ error.errorService.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="information-group pb-5 mt-8"
        v-show="isFieldShown('sampleProduct')"
      >
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Delivery Option Information</div>
        </div>
        <div class="px-6 py-3">
          <SampleProductDeliveryOption
            v-show="isFieldShown('sampleProduct')"
            :error="error"
            :form="form"
            :is-submit="isSubmit"
            :list-sample-pickup-stores="listSamplePickupStores"
          />
        </div>
      </div>

      <div
        class="information-group pb-5 mt-8"
        v-show="
          isFieldShown('rewardInformation') ||
          isFieldShown('voucherInformation') ||
          isFieldShown('categorySelected')
        "
      >
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Voucher Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row" v-show="isFieldShown('rewardInformation')">
            <div class="col-4">
              <label for="rewardType">Reward type</label>
              <multiselect
                id="rewardType"
                v-model="form.rewardType"
                :options="rewardTypeOptions"
                label="text"
                track-by="code"
                @input="changeRewardType"
                placeholder="เลือก Reward type"
              >
              </multiselect>
              <div v-if="isSubmit && error.errorRewardType" class="text-error">
                {{ error.errorRewardType.message }}
              </div>
            </div>
            <div class="col-4">
              <label for="rewardCategory">Reward categories</label>
              <multiselect
                id="rewardCategory"
                v-model="form.rewardCategories"
                :options="rewardCategoryOptions"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                label="text"
                track-by="id"
                placeholder="เลือก Reward categories"
              />
              <div
                v-if="isSubmit && error.errorRewardCategories"
                class="text-error"
              >
                {{ error.errorRewardCategories.message }}
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('voucherInformation')">
            <div class="col-4">
              <div>Voucher expiry type</div>
              <div class="d-flex flex-row pt-1">
                <div class="form-check form-check-inline pr-5">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="expiryType"
                    id="FIXED"
                    value="FIXED"
                    v-model="form.expiryType"
                  />
                  <label class="form-check-label" for="FIXED">Fixed date</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="expiryType"
                    id="PERIOD"
                    value="PERIOD"
                    v-model="form.expiryType"
                  />
                  <label class="form-check-label" for="PERIOD">Period</label>
                </div>
              </div>
              <div v-if="isSubmit && error.errorExpiryType" class="text-error">
                {{ error.errorExpiryType.message }}
              </div>
            </div>
            <div class="col-4" v-if="form.expiryType === 'FIXED'">
              <label for="expiryDate" required>Voucher expiry date</label>
              <date-picker
                id="expiryDate"
                v-bind="$attrs"
                v-model="form.expiryDate"
                format="D MMMM yyyy"
                lang="en"
                :value="form.expiryDate"
                @change="form.expiryDate = $event"
                style="margin-top: -0.6rem"
              />
              <div v-if="isSubmit && error.errorExpiryDate" class="text-error">
                {{ error.errorExpiryDate.message }}
              </div>
            </div>
            <div class="col-4" v-else-if="form.expiryType === 'PERIOD'">
              <label for="expiryDay">Voucher valid days</label>
              <NumberInput v-model.number="form.expiryDay" input-id="expiryDay" :is-decimal-allowed="true"/>
              <div v-if="isSubmit && error.errorExpiryDay" class="text-error">
                {{ error.errorExpiryDay.message }}
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('categorySelected')">
            <div class="col-4">
              <label for="selectedCategory">Voucher category</label>
              <multiselect
                id="selectedCategory"
                v-model="form.categorySelected"
                :options="categoryOptions"
                label="text"
                track-by="id"
              >
              </multiselect>
              <div v-if="isSubmit && error.errorCategory" class="text-error">
                {{ error.errorCategory.message }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="information-group pb-5 mt-8">
        <div class="row information-title-wrapper mx-0 my-0 px-2">
          <div class="information-title">Display Information</div>
        </div>
        <div class="px-6 py-3">
          <div class="row">
            <UploadAndPreviewImage
              identifier="privilegeThumbnailImage"
              v-show="isFieldShown('privilegeThumbnailImage')"
              label="Thumbnail image"
              :image-src="previewPrivilegeThumbnailImage"
              :upload-image="uploadPrivilegeThumbnailImage"
              :error-image="error.errorPrivilegeThumbnailImage"
              :is-submit="isSubmit"
            />
            <UploadAndPreviewImage
              identifier="voucherThumbnailImage"
              v-show="isFieldShown('voucherThumbnailImage')"
              label="Voucher thumbnail image"
              :image-src="previewVoucherThumbnailImage"
              :upload-image="uploadVoucherThumbnailImage"
              :error-image="error.errorVoucherThumbnailImage"
              :is-submit="isSubmit"
            />
          </div>
          <div class="row pt-5" v-show="isFieldShown('detailImages')">
            <div class="label-title">Detail images</div>
            <UploadAndPreviewImage
              identifier="previewDetailImage1"
              label="Detail images 1"
              :image-src="previewDetailImage1"
              :upload-image="uploadDetailImage1"
              :delete-image="deleteDetailImage1"
            />
            <UploadAndPreviewImage
              identifier="previewDetailImage4"
              label="Detail images 4"
              :image-src="previewDetailImage4"
              :upload-image="uploadDetailImage4"
              :delete-image="deleteDetailImage4"
            />
          </div>
          <div class="row" v-show="isFieldShown('detailImages')">
            <UploadAndPreviewImage
              identifier="previewDetailImage2"
              label="Detail images 2"
              :image-src="previewDetailImage2"
              :upload-image="uploadDetailImage2"
              :delete-image="deleteDetailImage2"
            />
            <UploadAndPreviewImage
              identifier="previewDetailImage5"
              label="Detail images 5"
              :image-src="previewDetailImage5"
              :upload-image="uploadDetailImage5"
              :delete-image="deleteDetailImage5"
            />
          </div>
          <div class="row" v-show="isFieldShown('detailImages')">
            <UploadAndPreviewImage
              identifier="previewDetailImage3"
              label="Detail images 3"
              :image-src="previewDetailImage3"
              :upload-image="uploadDetailImage3"
              :delete-image="deleteDetailImage3"
            />
            <div class="col" />
          </div>
          <div class="row">
            <div class="offset-10 col-2">
              <label for="selectedLanguage">Language</label>
              <multiselect
                id="selectedLanguage"
                v-model="langSelect"
                :options="[{ text: 'TH' }, { text: 'EN' }]"
                label="text"
                track-by="text"
              >
              </multiselect>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label :for="'voucherName_' + langSelect.text"
                >Voucher name ({{ langSelect.text }})</label
              >
              <div v-show="langSelect.text === 'TH'">
                <input
                  id="voucherName_TH"
                  type="text"
                  v-model="form.nameTh"
                  class="form-control"
                />
                <div v-if="isSubmit && error.errorNameTh" class="text-error">
                  {{ error.errorNameTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <input
                  id="voucherName_EN"
                  type="text"
                  v-model="form.nameEn"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label :for="'shortDescription_' + langSelect.text"
                >Short description ({{ langSelect.text }})</label
              >
              <div v-show="langSelect.text === 'TH'">
                <input
                  id="shortDescription_TH"
                  type="text"
                  v-model="form.shortDescriptionTh"
                  class="form-control"
                />
                <div
                  v-if="isSubmit && error.errorShortDescriptionTh"
                  class="text-error"
                >
                  {{ error.errorShortDescriptionTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <input
                  id="shortDescription_EN"
                  type="text"
                  v-model="form.shortDescriptionEn"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label :for="'description_' + langSelect.text">
                Description ({{ langSelect.text }})</label
              >
              <div v-show="langSelect.text === 'TH'">
                <textarea
                  id="description_TH"
                  v-model="form.descriptionTh"
                  class="form-control"
                  rows="4"
                ></textarea>
                <div
                  v-if="isSubmit && error.errorDescriptionTh"
                  class="text-error"
                >
                  {{ error.errorDescriptionTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <textarea
                  id="description_EN"
                  v-model="form.descriptionEn"
                  class="form-control"
                  rows="4"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('sampleProductDetail')">
            <div class="col">
              <label :for="'detail_' + langSelect.text"
                >Sample product detail ({{ langSelect.text }})</label
              >
              <div v-show="langSelect.text === 'TH'">
                <CkEditor
                  id="detail_TH"
                  :value="form.sampleProductDetailTh"
                  :isTh="true"
                  @setContent="setContentSampleProduct"
                ></CkEditor>
                <div
                  v-if="isSubmit && error.errorSampleProductDetailTh"
                  class="text-error"
                >
                  {{ error.errorSampleProductDetailTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <CkEditor
                  id="detail_EN"
                  :value="form.sampleProductDetailEn"
                  :isTh="false"
                  @setContent="setContentSampleProduct"
                ></CkEditor>
                <div
                  v-if="isSubmit && error.errorSampleProductDetailEn"
                  class="text-error"
                >
                  {{ error.errorSampleProductDetailEn.message }}
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="isFieldShown('conditions')">
            <div class="col">
              <label :for="'condition_' + langSelect.text"
                >Conditions ({{ langSelect.text }})</label
              >
              <div v-show="langSelect.text === 'TH'">
                <CkEditor
                  id="condition_TH"
                  :value="form.conditionTh"
                  :isTh="true"
                  @setContent="setContent"
                ></CkEditor>
                <div
                  v-if="isSubmit && error.errorConditionTh"
                  class="text-error"
                >
                  {{ error.errorConditionTh.message }}
                </div>
              </div>
              <div v-show="langSelect.text === 'EN'">
                <CkEditor
                  id="condition_EN"
                  :value="form.conditionEn"
                  :isTh="false"
                  @setContent="setContent"
                ></CkEditor>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'Privilege' }"
          class="btn btn-outline-danger btn-cancel"
          >Cancel
        </router-link>
        <button
          class="btn btn-outline-warning btn-label ml-10"
          v-if="
            form.voucherSelected &&
            form.voucherSelected.code === 'SAMPLE_PRODUCT'
          "
          @click="goToDeliveryLabel"
        >
          Label
        </button>
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && id">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="mt-5">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'Privilege' })"
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn-back"
            @click="showDialog = false"
          >
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import CkEditor from "components/CkEditor/CkEditor";
import ProductService from "services/api/product.service";
import StoresByRetailerService from "services/api/storesByRetailer.service";
import PrivilegeCategoryService from "services/api/privilegeCategory.service";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import PrivilegeService from "services/api/privilege.service";
import BookingService from "services/api/booking.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import ListProductVariances from "./ListProductVariances.vue";
import SampleProductDeliveryOption from "@/views/Privilege/SampleProductDeliveryOption.vue";
import DatePicker from "components/Datepicker/Datepicker.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";
import UploadAndPreviewImage from "@/views/Privilege/UploadAndPreviewImage.vue";
import SampleProductService from "services/api/sampleProduct.service";
import PrivilegeErrorFields from "@/views/Privilege/privilegeErrorFields";
import RewardCategoryService from "services/api/rewardCategory.service";
import { ProductTypeOption } from "@/views/Privilege/productTypeOption";
import ListSelectedSubBundles from "@/views/Privilege/ListSelectedSubBundles.vue";
import TopSpenderCampaignSection from "@/views/Privilege/TopSpenderCampaignSection.vue";

export default {
  computed: {
    ProductTypeOption() {
      return ProductTypeOption;
    },
    isServiceReservationEnabled() {
      return process.env.VUE_APP_FEATURE_SERVICE_RESERVATION_ENABLED === "true";
    },
  },
  components: {
    NumberInput,
    ListSelectedSubBundles,
    TopSpenderCampaignSection,
    DatePicker,
    SampleProductDeliveryOption,
    CkEditor,
    BrandDropdown,
    ListProductVariances,
    UploadAndPreviewImage,
  },
  data() {
    return {
      id: this.$route.query.id,
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      langSelect: { text: "TH" },
      isupdated: false,
      voucherOptions: [
        { text: "Membership", code: "MEMBERSHIP" },
        { text: "Promotion", code: "PROMOTION" },
        { text: "Yearend", code: "YEAREND" },
        { text: "Catalog", code: "CATALOG" },
        { text: "Sample product", code: "SAMPLE_PRODUCT" },
        { text: "Sub Bundle", code: "SUB_BUNDLE" },
        { text: "Referral Coupon", code: "REFERRAL_COUPON" },
      ],
      yearendOptions: Array.from({ length: 3 }, (_, b) => {
        return { text: new Date().getFullYear() - b };
      }),
      rewardTypeOptions: [
        { text: "Rewards", code: "REWARDS" },
        { text: "Packages", code: "PACKAGES" },
      ],
      rewardCategoryOptions: [],
      productOptions: [],
      storeOptions: [],
      categoryOptions: [],
      subBundleOptions: [],
      selectedBrandId: null,
      multiple: true,
      clearable: true,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      rtl: false,
      varianceNameTh: "",
      varianceNameEn: "",
      productQuota: 0,
      subBundleSelected: null,
      subBundleQuantity: 0,
      productVarianceSelected: null,
      listProductVariances: [],
      listSamplePickupStores: [],
      listSelectedSubBundles: [],
      brandSelected: null,
      isProductVarianceAdded: false,
      duplicateProductVarianceMessage: null,
      isSubBundleAdded: false,
      duplicateSubBundleMessage: null,
      serviceSelected: null,
      serviceOptions: [],
      form: {
        id: null,
        voucherSelected: null,
        pickupStores: [],
        isAnyStore: false,
        yearendSelected: null,
        redeemStartDate: null,
        redeemEndDate: null,
        limit: null,
        productType: "SINGLE_PRODUCT",
        voucherTypeCode: null,
        point: null,
        status: false,
        booking: false,
        expiryType: null,
        expiryDate: null,
        expiryDay: null,
        categorySelected: null,
        privilegeThumbnailImage: null,
        voucherThumbnailImage: null,
        detailImage1: null,
        detailImage2: null,
        detailImage3: null,
        detailImage4: null,
        detailImage5: null,
        nameTh: null,
        nameEn: null,
        shortDescriptionTh: null,
        shortDescriptionEn: null,
        descriptionTh: null,
        descriptionEn: null,
        sampleProductDetailTh: null,
        sampleProductDetailEn: null,
        conditionTh: null,
        conditionEn: null,
        quota: null,
        isAllowDelivery: false,
        deliveryQuota: null,
        remainingDeliveryQuota: null,
        deliveryLeadTimeInDay: null,
        isAllowPickup: false,
        pickupCountersWithQuotaTempFile: null,
        currentPickupCountersWithQuotaFile: null,
        pickupDateFrom: null,
        pickupDateTo: null,
        rewardType: { code: null, text: null },
        rewardCategories: [],
        topSpenderCampaign: false,
        campaignPurchaseCalculationStartDate: null,
        campaignPurchaseCalculationEndDate: null,
        campaignMinimumSpending: null,
        campaignBanner: null,
        campaignDetailTh: null,
        campaignDetailEn: null,
      },
      previewPrivilegeThumbnailImage: null,
      privilegeThumbnailImageFile: null,

      previewVoucherThumbnailImage: null,
      voucherThumbnailImageFile: null,

      previewDetailImage1: null,
      detailImageFile1: null,

      previewDetailImage2: null,
      detailImageFile2: null,

      previewDetailImage3: null,
      detailImageFile3: null,

      previewDetailImage4: null,
      detailImageFile4: null,

      previewDetailImage5: null,
      detailImageFile5: null,

      previewCampaignBannerUrl: null,
      campaignBannerFile: null,

      isSubmit: false,
      totalProduct: 0,
      error: {
        ...PrivilegeErrorFields,
      },
      frontendHost: process.env.VUE_APP_HOST_FRONTEND,
      accessLink: null,
      copyText: "copy",
    };
  },
  async mounted() {
    if (this.id) {
      await this.bindingData(this.id);
      if (
        this.form.voucherSelected &&
        this.form.voucherSelected.code === "SAMPLE_PRODUCT"
      ) {
        this.accessLink = `${this.frontendHost}sample-product/${this.id}?invitation-code=${this.brandSelected}`;
      }
    }
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      const form = this.form;
      const body = {
        brandCode: this.brandSelected?.id,
        type: form.voucherSelected ? form.voucherSelected.code : null,
        status:
          form.status === true || form.status === "ACTIVE"
            ? "ACTIVE"
            : "INACTIVE",
        nameTh: form.nameTh,
        shortDescriptionTh: form.shortDescriptionTh,
        descriptionTh: form.descriptionTh,
        nameEn: form.nameEn,
        shortDescriptionEn: form.shortDescriptionEn,
        descriptionEn: form.descriptionEn,
        productType: form.productType,
        parentCode:
          form.productType === ProductTypeOption.SingleProduct
            ? this.productVarianceSelected?.code
            : undefined,
        isBooking:
          (form.productType === ProductTypeOption.SingleProduct ||  form.productType === ProductTypeOption.ProductVariance)
            ? form.booking
            : undefined,
        serviceId:
          (form.productType === ProductTypeOption.SingleProduct ||  form.productType === ProductTypeOption.ProductVariance)
            ? this.serviceSelected?.id
            : undefined,
      };
      const fieldList = this.getFieldListSentToApi(body.type, body);
      if (this.id) {
        this.addOrEditPrivilege(fieldList, true);
      } else {
        this.addOrEditPrivilege(fieldList);
      }
    },
    async addOrEditPrivilege(body, isUpdate = false) {
      await PrivilegeService.createOrUpdatePrivilege(body, this.id, isUpdate)
        .then((res) => {
          this.isLoading = false;
          const data = res.data;
          this.resetErrorText();
          this.message = data.message;
          this.showDialog = true;
          this.showSuccess = true;
        })
        .catch((err) => {
          this.isLoading = false;
          this.resetErrorText();

          const errorData = err.response?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
            return;
          }
          if (errorData.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    addProductVariance() {
      this.isProductVarianceAdded = true;
      this.duplicateProductVarianceMessage = null;
      const isDuplicateVariance = this.listProductVariances.some(
        (product) => product.productCode === this.productVarianceSelected.code
      );
      if (isDuplicateVariance) {
        this.duplicateProductVarianceMessage = "มีผลิตภัณ์นี้ในรายการแล้ว";
      } else {
        this.listProductVariances.push({
          variancesNameTh: this.varianceNameTh,
          variancesNameEn: this.varianceNameEn,
          productCode: this.productVarianceSelected.code,
          quota: this.productQuota,
          isEdit: false,
        });
        this.resetProductInformationValue();
      }
    },
    deleteProductVariance(index) {
      this.listProductVariances.forEach((_, i) => {
        if (i === index) {
          this.listProductVariances.splice(index, 1);
        }
      });
    },
    resetProductInformationValue() {
      this.varianceNameTh = "";
      this.varianceNameEn = "";
      this.productVarianceSelected = null;
      this.productQuota = 0;
    },
    addSubBundle() {
      this.isSubBundleAdded = true;
      this.duplicateSubBundleMessage = null;
      const isDuplicateSubBundle = this.listSelectedSubBundles.some(
        (subBundle) => subBundle.id === this.subBundleSelected.id
      );
      if (isDuplicateSubBundle) {
        this.duplicateSubBundleMessage = "มีผลิตภัณ์นี้ในรายการแล้ว";
      } else {
        this.listSelectedSubBundles.push({
          id: this.subBundleSelected?.id,
          nameTh: this.subBundleSelected?.nameTh,
          nameEn: this.subBundleSelected?.nameEn,
          parentCode: this.subBundleSelected?.parentCode,
          quantity: this.subBundleQuantity,
          isEdit: false,
        });
        this.resetSubBundleValue();
      }
    },
    deleteSubBundle(index) {
      this.listSelectedSubBundles.forEach((_, i) => {
        if (i === index) {
          this.listSelectedSubBundles.splice(index, 1);
        }
      });
    },
    resetSubBundleValue() {
      this.subBundleSelected = "";
      this.subBundleQuantity = 0;
    },
    getFieldListSentToApi(voucherCode, body) {
      const form = this.form;
      const topSpenderCampaignPayload = form.topSpenderCampaign
          ? {
            isEnabled: true,
            campaignPurchaseCalculationStartDate: moment(form.campaignPurchaseCalculationStartDate).format("DD/MM/YYYY"),
            campaignPurchaseCalculationEndDate: moment(form.campaignPurchaseCalculationEndDate).format("DD/MM/YYYY"),
            campaignMinimumSpending: form.campaignMinimumSpending,
            campaignBanner: form.campaignBanner,
            campaignDetailTh: form.campaignDetailTh,
            campaignDetailEn: form.campaignDetailEn,
          }
          : { isEnabled: false };

      const sharedVoucherBase = {
        ...body,
        voucherThumbnailImage: form.voucherThumbnailImage,
        conditionTh: form.conditionTh,
        conditionEn: form.conditionEn,
        ...this.getRewardPayload(form),
      };

      const builders = {
        MEMBERSHIP: () => sharedVoucherBase,
        REFERRAL_COUPON: () => ({ ...sharedVoucherBase, ...this.getExpiryPayload(form) }),
        PROMOTION: () => ({
          ...sharedVoucherBase,
          voucherTypeCode: form.voucherTypeCode,
          category: form.categorySelected?.id ?? null,
        }),
        YEAREND: () => ({ ...this.getYearEndAndCatalogBase(form, body), pointYear: form.yearendSelected?.text ?? null }),
        CATALOG: () => ({ ...this.getYearEndAndCatalogBase(form, body), topSpenderCampaign: topSpenderCampaignPayload }),
        SAMPLE_PRODUCT: () => ({
          ...body,
          redeemStartDate: moment(form.redeemStartDate).format("DD/MM/YYYY"),
          redeemEndDate: moment(form.redeemEndDate).format("DD/MM/YYYY"),
          limit: form.limit,
          isAllowDelivery: form.isAllowDelivery,
          deliveryQuota: form.deliveryQuota,
          deliveryLeadTimeInDay: form.deliveryLeadTimeInDay,
          isAllowPickup: form.isAllowPickup,
          pickupDateFrom: moment(form.pickupDateFrom).format("DD/MM/YYYY"),
          pickupDateTo: moment(form.pickupDateTo).format("DD/MM/YYYY"),
          pickupCountersWithQuotaTempFile: form.pickupCountersWithQuotaTempFile,
          voucherThumbnailImage: form.voucherThumbnailImage,
          sampleProductDetailTh: form.sampleProductDetailTh,
          sampleProductDetailEn: form.sampleProductDetailEn,
          ...this.getRewardPayload(form),
        }),
        SUB_BUNDLE: () => ({
          ...body,
          isAnyStore: this.isAnyStoreValue(),
          pickupStores: form.pickupStores,
          privilegeThumbnailImage: form.privilegeThumbnailImage,
          voucherThumbnailImage: form.voucherThumbnailImage,
          detailImage1: form.detailImage1,
          detailImage2: form.detailImage2,
          detailImage3: form.detailImage3,
          detailImage4: form.detailImage4,
          detailImage5: form.detailImage5,
          isAllowDelivery: form.isAllowDelivery,
          conditionTh: form.conditionTh,
          conditionEn: form.conditionEn,
          ...this.getExpiryPayload(form),
          ...this.getRewardPayload(form),
        }),
      };

      return builders[voucherCode]?.() ?? {};
    },
    getRewardPayload(form) {
      return {
        rewardType: form.rewardType?.code,
        rewardCategories: form.rewardCategories?.map((r) => r.id),
      };
    },
    getExpiryPayload(form) {
      return {
        expiryType: form.expiryType,
        expiryDate: form.expiryType === "FIXED" ? moment(form.expiryDate).format("DD/MM/YYYY") : undefined,
        expiryDay: form.expiryType === "PERIOD" ? form.expiryDay : undefined,
      };
    },
    getYearEndAndCatalogBase(form, body) {
      const base = {
        ...body,
        isAnyStore: this.isAnyStoreValue(),
        pickupStores: form.pickupStores,
        redeemStartDate: moment(form.redeemStartDate).format("DD/MM/YYYY"),
        redeemEndDate: moment(form.redeemEndDate).format("DD/MM/YYYY"),
        limit: form.limit,
        point: form.point,
        productVariances: form.productType === ProductTypeOption.ProductVariance
            ? this.listProductVariances.map((s) => ({ nameTh: s.variancesNameTh, nameEn: s.variancesNameEn, parentCode: s.productCode, quota: s.quota }))
            : [],
        subBundles: form.productType === ProductTypeOption.ProductBundle
            ? this.listSelectedSubBundles.map((s) => ({ id: s.id, quantity: s.quantity }))
            : [],
        quota: form.productType === ProductTypeOption.ProductVariance ? undefined : this.productQuota,
        privilegeThumbnailImage: form.privilegeThumbnailImage,
        voucherThumbnailImage: form.voucherThumbnailImage,
        detailImage1: form.detailImage1,
        detailImage2: form.detailImage2,
        detailImage3: form.detailImage3,
        detailImage4: form.detailImage4,
        detailImage5: form.detailImage5,
        isAllowDelivery: form.isAllowDelivery,
        conditionTh: form.conditionTh,
        conditionEn: form.conditionEn,
      };
      if (form.productType !== ProductTypeOption.ProductBundle) {
        return { ...base, ...this.getExpiryPayload(form), ...this.getRewardPayload(form) };
      }
      return base;
    },
    isAnyStoreValue() {
      if (this.form.isAnyStore) {
        return this.form.isAnyStore;
      } else if (this.form.pickupStores?.length > 0) {
        return false;
      } else {
        return null;
      }
    },
    async bindingData(id) {
      this.isLoading = true;
      this.isupdated = true;
      await PrivilegeService.getDetailPrivilege(id)
        .then(async (res) => {
          const data = await res.data.privilege;
          if (
            data.privilegeType === "SAMPLE_PRODUCT" &&
            data.isAllowPickup === true
          ) {
            await this.getPickupStoreList();
          }
          if (data.brandCode && data.privilegeStatus) {
            this.selectedBrandId = data.brandCode;
            this.brandSelected = data.brandCode;
            this.form.status = data.privilegeStatus === "ACTIVE";
            await this.getProducts();
            await this.getServices();
            await this.getStoresByRetailer();
            await this.getPrivilegeCategories();
            await this.getRewardCategories(data.rewardType?.code);
            await this.getSubBundles();

            this.isLoading = false;

            let listRewardCategories = [];
            data.rewardCategories.map((i) => {
              let item = this.rewardCategoryOptions?.find((r) => r.id === i);
              if (item !== undefined) {
                listRewardCategories.push(item);
              }
            });
            this.serviceSelected = this.serviceOptions.find(
              (s) => s.id === data.serviceId
            );
            this.productVarianceSelected = this.productOptions.find(
              (s) => s.code === data.parentCode
            );
            this.productQuota = data.quota;
            if (data.productType === ProductTypeOption.ProductVariance) {
              this.listProductVariances = data.productVariances.map((s) => {
                return {
                  ...s,
                  variancesNameTh: s.nameTh,
                  variancesNameEn: s.nameEn,
                  productCode: s.parentCode,
                  quota: s.quota,
                  isEdit: false,
                };
              });
            }
            if (data.productType === ProductTypeOption.ProductBundle) {
              this.listSelectedSubBundles = data.subBundles.map((s) => {
                return {
                  ...s,
                  variancesNameTh: s.nameTh,
                  variancesNameEn: s.nameEn,
                  productCode: s.parentCode,
                  quantity: s.quantity,
                  isEdit: false,
                };
              });
            }
            this.form = {
              id: data.id,
              voucherSelected: this.voucherOptions.find(
                (s) => s.code === data.privilegeType
              ),
              pickupStores: data.pickupStores,
              isAnyStore: data.isAnyStore,
              yearendSelected: this.yearendOptions.find(
                (s) => s.text === data.pointYear
              ),
              categorySelected: this.categoryOptions.find(
                (s) => s.id === data.categoryId
              ),
              redeemStartDate: data.redeemStartDate,
              redeemEndDate: data.redeemEndDate,
              limit: data.privilegeLimit,
              productType: data.productType,
              voucherTypeCode: data.voucherTypeCode,
              point: data.point,
              status: data.privilegeStatus === "ACTIVE",
              booking: data.isBooking,
              expiryType: data.expiryType,
              expiryDate: data.expiryDate,
              expiryDay: data.expiryDay,
              category: data.category,
              privilegeThumbnailImage: data.privilegeThumbnailImage,
              voucherThumbnailImage: data.voucherThumbnailImage,
              detailImage1: data.detailImage1,
              detailImage2: data.detailImage2,
              detailImage3: data.detailImage3,
              detailImage4: data.detailImage4,
              detailImage5: data.detailImage5,
              nameTh: data.nameTh,
              shortDescriptionTh: data.shortDescriptionTh,
              descriptionTh: data.descriptionTh,
              conditionTh: data.conditionTh,
              sampleProductDetailTh: data.sampleProductDetailTh,
              nameEn: data.nameEn,
              shortDescriptionEn: data.shortDescriptionEn,
              descriptionEn: data.descriptionEn,
              conditionEn: data.conditionEn,
              sampleProductDetailEn: data.sampleProductDetailEn,
              quota: data.quota,
              isAllowDelivery: data.isAllowDelivery,
              deliveryQuota: data.deliveryQuota,
              remainingDeliveryQuota: data.remainingDeliveryQuota,
              deliveryLeadTimeInDay: data.deliveryLeadTimeInDay,
              isAllowPickup: data.isAllowPickup,
              pickupDateFrom: data.pickupDateFrom,
              pickupDateTo: data.pickupDateTo,
              pickupCountersWithQuotaTempFile:
                data.pickupCountersWithQuotaTempFile,
              currentPickupCountersWithQuotaFile:
                data.currentPickupCountersWithQuotaFile,
              rewardType: this.rewardTypeOptions.find(
                (s) => s.code === data.rewardType
              ),
              rewardCategories: listRewardCategories,
              topSpenderCampaign: data.topSpenderCampaign?.isEnabled || false,
              campaignPurchaseCalculationStartDate: data.topSpenderCampaign?.campaignPurchaseCalculationStartDate || null,
              campaignPurchaseCalculationEndDate: data.topSpenderCampaign?.campaignPurchaseCalculationEndDate || null,
              campaignMinimumSpending: data.topSpenderCampaign?.campaignMinimumSpending,
              campaignBanner: data.topSpenderCampaign?.campaignBanner,
              campaignDetailTh: data.topSpenderCampaign?.campaignDetailTh,
              campaignDetailEn: data.topSpenderCampaign?.campaignDetailEn,
            };
            this.previewPrivilegeThumbnailImage =
              data.privilegeThumbnailImageUrl;
            this.previewVoucherThumbnailImage = data.voucherThumbnailImageUrl;
            this.previewDetailImage1 = data.detailImage1Url;
            this.previewDetailImage2 = data.detailImage2Url;
            this.previewDetailImage3 = data.detailImage3Url;
            this.previewDetailImage4 = data.detailImage4Url;
            this.previewDetailImage5 = data.detailImage5Url;
            this.previewCampaignBannerUrl = data.topSpenderCampaign?.campaignBannerUrl;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
        });
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    async getProducts() {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brand: brandCode,
      };
      await ProductService.getListProducts(params)
        .then((res) => {
          const data = res.data;
          this.totalProduct = data.totalItems;
          this.productOptions = data.product.map((s) => {
            return {
              id: s.productCode,
              text: s.productName,
              fullText: `(${s.productCode}) ${s.productName}`,
              code: s.productCode,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getServices() {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brandCode: brandCode,
      };
      await BookingService.getServices(params)
        .then((res) => {
          const data = res.data;
          this.serviceOptions = data.items
            .map((s) => {
              return {
                id: s.key,
                text: s.value,
              };
            })
            .sort(function (a, b) {
              return a.text.localeCompare(b.text);
            });
          if (this.serviceSelected) {
            this.serviceSelected = this.serviceOptions.find(
              (s) => s.id === this.serviceSelected.id
            );
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getStoresByRetailer() {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brandCode: brandCode,
      };
      await StoresByRetailerService.getListStoresByRetailer(params)
        .then((res) => {
          const data = res.data;
          this.storeOptions = data.storesByRetailer.map((s) => {
            return {
              id: s.retailerName,
              label: s.retailerName,
              children: s.stores.map((d) => {
                return {
                  id: d.storeCode,
                  label: d.storeName,
                };
              }),
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getPrivilegeCategories() {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brandCode: brandCode,
        status: "ACTIVE",
      };
      await PrivilegeCategoryService.getListPrivilegeCategories(params)
        .then((res) => {
          const data = res.data;
          this.categoryOptions = data.privilegeCategorys.map((s) => {
            return {
              id: s.id,
              text: s.nameTh,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getPickupStoreList() {
      const params = {
        id: this.$route.query.id,
      };
      await SampleProductService.getListSamplePickupCounter(params)
        .then((res) => {
          const data = res.data;
          this.listSamplePickupStores = data.samplePickupCounters;
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getRewardCategories(rewardTypeCode) {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brandCode: brandCode,
        status: "ACTIVE",
        rewardType: rewardTypeCode,
      };
      await RewardCategoryService.getListRewardCategory(params)
        .then((res) => {
          const data = res.data;
          this.rewardCategoryOptions = data.rewardCategories.map((r) => {
            return {
              id: r.id,
              text: r.nameTh,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    async getSubBundles() {
      const brandCode = this.brandSelected.id
        ? this.brandSelected.id
        : this.brandSelected;
      const params = {
        brandCode: brandCode,
      };
      await PrivilegeService.getListSubBundle(params)
        .then((res) => {
          const data = res.data;
          this.subBundleOptions = data.subBundles.map((s) => {
            return {
              id: s.id,
              text: s.name,
              nameTh: s.nameTh,
              nameEn: s.nameEn,
              parentCode: s.parentCode,
            };
          });
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    changeRewardType() {
      this.form.rewardCategories = [];
      if (this.brandSelected) {
        this.getRewardCategories(this.form.rewardType?.code);
      }
    },
    setErrorText(errors) {
      this.error.errorBrand = errors.find((e) => e.fieldName === "brand");
      this.error.errorBrandCode = errors.find(
        (e) => e.fieldName === "brandCode"
      );
      this.error.errorType = errors.find((e) => e.fieldName === "type");
      this.error.errorParentCode = errors.find(
        (e) => e.fieldName === "parentCode"
      );
      this.error.errorProductType = errors.find(
        (e) => e.fieldName === "productType"
      );
      this.error.errorIsAnyStore = errors.find(
        (e) => e.fieldName === "isAnyStore"
      );
      this.error.errorRedeemStartDate = errors.find(
        (e) => e.fieldName === "redeemStartDate"
      );
      this.error.errorRedeemEndDate = errors.find(
        (e) => e.fieldName === "redeemEndDate"
      );
      this.error.errorLimit = errors.find((e) => e.fieldName === "limit");
      this.error.errorQuota = errors.find((e) => e.fieldName === "quota");
      this.error.errorExpiryDate = errors.find(
        (e) => e.fieldName === "expiryDate"
      );
      this.error.errorNameTh = errors.find((e) => e.fieldName === "nameTh");
      this.error.errorShortDescriptionTh = errors.find(
        (e) => e.fieldName === "shortDescriptionTh"
      );
      this.error.errorDescriptionTh = errors.find(
        (e) => e.fieldName === "descriptionTh"
      );
      this.error.errorCategory = errors.find((e) => e.fieldName === "category");
      this.error.errorConditionTh = errors.find(
        (e) => e.fieldName === "conditionTh"
      );
      this.error.errorSampleProductDetailTh = errors.find(
        (e) => e.fieldName === "sampleProductDetailTh"
      );
      this.error.errorSampleProductDetailEn = errors.find(
        (e) => e.fieldName === "sampleProductDetailEn"
      );
      this.error.errorVoucherThumbnailImage = errors.find(
        (e) => e.fieldName === "voucherThumbnailImage"
      );
      this.error.errorPrivilegeThumbnailImage = errors.find(
        (e) => e.fieldName === "privilegeThumbnailImage"
      );
      this.error.errorPoint = errors.find((e) => e.fieldName === "point");
      this.error.errorPointYear = errors.find(
        (e) => e.fieldName === "pointYear"
      );
      this.error.errorExpiryDay = errors.find(
        (e) => e.fieldName === "expiryDay"
      );
      this.error.errorExpiryType = errors.find(
        (e) => e.fieldName === "expiryType"
      );
      this.error.errorNameEn = errors.find((e) => e.fieldName === "nameEn");
      this.error.errorPickupStores = errors.find(
        (e) => e.fieldName === "pickupStores"
      );
      this.error.errorPrivilegeType = errors.find(
        (e) => e.fieldName === "privilegeType"
      );
      this.error.errorIsAllowDelivery = errors.find(
        (e) => e.fieldName === "isAllowDelivery"
      );
      this.error.errorDeliveryQuota = errors.find(
        (e) => e.fieldName === "deliveryQuota"
      );
      this.error.errorDeliveryLeadTimeInDay = errors.find(
        (e) => e.fieldName === "deliveryLeadTimeInDay"
      );
      this.error.errorIsAllowPickup = errors.find(
        (e) => e.fieldName === "isAllowPickup"
      );
      this.error.errorPickupCountersWithQuotaTempFile = errors.find(
        (e) => e.fieldName === "pickupCountersWithQuotaTempFile"
      );
      this.error.errorPickupDateFrom = errors.find(
        (e) => e.fieldName === "pickupDateFrom"
      );
      this.error.errorPickupDateTo = errors.find(
        (e) => e.fieldName === "pickupDateTo"
      );
      this.error.errorRewardType = errors.find(
        (e) => e.fieldName === "rewardType"
      );
      this.error.errorRewardCategories = errors.find(
        (e) => e.fieldName === "rewardCategories"
      );
      this.error.errorCampaignPurchaseCalculationStartDate = errors.find(
        (e) => e.fieldName === "campaignPurchaseCalculationStartDate"
      );
      this.error.errorCampaignPurchaseCalculationEndDate = errors.find(
        (e) => e.fieldName === "campaignPurchaseCalculationEndDate"
      );
      this.error.errorCampaignMinimumSpending = errors.find(
        (e) => e.fieldName === "campaignMinimumSpending"
      );
      this.error.errorCampaignBanner = errors.find(
        (e) => e.fieldName === "campaignBanner"
      );
      this.error.errorCampaignDetailTh = errors.find(
        (e) => e.fieldName === "campaignDetailTh"
      );
      this.error.errorCampaignDetailEn = errors.find(
        (e) => e.fieldName === "campaignDetailEn"
      );
      this.error.errorService =
        errors.find((e) => e.fieldName === "serviceId") ??
        errors.find((e) => e.fieldName === "isBooking");
    },
    resetErrorText() {
      this.error = {
        ...PrivilegeErrorFields,
      };
    },
    deleteDetailImage1() {
      this.form.detailImage1 = "";
      this.previewDetailImage1 = "";
      this.detailImageFile1 = "";
    },
    deleteDetailImage2() {
      this.form.detailImage2 = "";
      this.previewDetailImage2 = "";
      this.detailImageFile2 = "";
    },
    deleteDetailImage3() {
      this.form.detailImage3 = "";
      this.previewDetailImage3 = "";
      this.detailImageFile3 = "";
    },
    deleteDetailImage4() {
      this.form.detailImage4 = "";
      this.previewDetailImage4 = "";
      this.detailImageFile4 = "";
    },
    deleteDetailImage5() {
      this.form.detailImage5 = "";
      this.previewDetailImage5 = "";
      this.detailImageFile5 = "";
    },
    changeStartDate(val) {
      if (val > this.form.redeemEndDate) {
        this.form.redeemEndDate = null;
      }
    },
    async uploadPrivilegeThumbnailImage(e) {
      if (e.target.files) {
        this.privilegeThumbnailImageFile = e.target.files[0];
        this.previewPrivilegeThumbnailImage = URL.createObjectURL(
          this.privilegeThumbnailImageFile
        );
      }
      await this.getPresignURL(this.privilegeThumbnailImageFile);
    },
    async uploadVoucherThumbnailImage(e) {
      if (e.target.files) {
        this.voucherThumbnailImageFile = e.target.files[0];
        this.previewVoucherThumbnailImage = URL.createObjectURL(
          this.voucherThumbnailImageFile
        );
      }
      await this.getPresignURL(this.voucherThumbnailImageFile);
    },
    async uploadDetailImage1(e) {
      if (e.target.files) {
        this.detailImageFile1 = e.target.files[0];
        this.previewDetailImage1 = URL.createObjectURL(this.detailImageFile1);
      }
      await this.getPresignURL(this.detailImageFile1);
    },
    async uploadDetailImage2(e) {
      if (e.target.files) {
        this.detailImageFile2 = e.target.files[0];
        this.previewDetailImage2 = URL.createObjectURL(this.detailImageFile2);
      }
      await this.getPresignURL(this.detailImageFile2);
    },
    async uploadDetailImage3(e) {
      if (e.target.files) {
        this.detailImageFile3 = e.target.files[0];
        this.previewDetailImage3 = URL.createObjectURL(this.detailImageFile3);
      }
      await this.getPresignURL(this.detailImageFile3);
    },
    async uploadDetailImage4(e) {
      if (e.target.files) {
        this.detailImageFile4 = e.target.files[0];
        this.previewDetailImage4 = URL.createObjectURL(this.detailImageFile4);
        await this.getPresignURL(this.detailImageFile4);
      }
    },
    async uploadDetailImage5(e) {
      if (e.target.files) {
        this.detailImageFile5 = e.target.files[0];
        this.previewDetailImage5 = URL.createObjectURL(this.detailImageFile5);
      }
      await this.getPresignURL(this.detailImageFile5);
    },
    async uploadCampaignBanner(e) {
      if (e.target.files) {
        const file = e.target.files[0];
        const allowedTypes = ["image/jpeg", "image/png"];
        const maxSizeBytes = 10 * 1024 * 1024;

        if (!allowedTypes.includes(file.type)) {
          this.error.errorCampaignBanner = { message: "Only PNG and JPEG images are allowed." };
          return;
        }
        if (file.size > maxSizeBytes) {
          this.error.errorCampaignBanner = { message: "Image size must not exceed 10MB." };
          return;
        }

        this.error.errorCampaignBanner = null;
        this.campaignBannerFile = file;
        this.previewCampaignBannerUrl = URL.createObjectURL(this.campaignBannerFile);
      }
      await this.getPresignURL(this.campaignBannerFile);
    },
    async getPresignURL(file) {
      this.isLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("privilege", file)
        .then((res) => {
          const data = res.data;
          if (file === this.privilegeThumbnailImageFile) {
            this.form.privilegeThumbnailImage = data.key;
          } else if (file === this.voucherThumbnailImageFile) {
            this.form.voucherThumbnailImage = data.key;
          } else if (file === this.detailImageFile1) {
            this.form.detailImage1 = data.key;
          } else if (file === this.detailImageFile2) {
            this.form.detailImage2 = data.key;
          } else if (file === this.detailImageFile3) {
            this.form.detailImage3 = data.key;
          } else if (file === this.detailImageFile4) {
            this.form.detailImage4 = data.key;
          } else if (file === this.detailImageFile5) {
            this.form.detailImage5 = data.key;
          } else if (file === this.campaignBannerFile) {
            this.form.campaignBanner = data.key;
          }

          if (data.status === "failure") {
            this.isLoading = false;
            this.showDialog = true;
            this.message = data.message;
          } else {
            this.updatePhotoToS3(data.presignedUrl, file);
          }
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isLoading = false;
    },
    setContent(content, isTh = true) {
      if (isTh) {
        this.form.conditionTh = content || "";
      } else {
        this.form.conditionEn = content || "";
      }
    },
    setContentSampleProduct(content, isTh = true) {
      if (isTh) {
        this.form.sampleProductDetailTh = content || "";
      } else {
        this.form.sampleProductDetailEn = content || "";
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      if (this.isupdated === false) {
        this.changeBrand();
      }
    },
    setBrands(brands) {
      const listBrands = brands;
      listBrands.forEach((brand) => {
        if (brand.id === this.brandSelected) {
          this.brandSelected = brand;
        }
      });
    },
    changeBrand() {
      this.form.productSelected = null;
      this.form.categorySelected = null;
      this.form.rewardCategories = null;
      this.form.pickupStores = [];
      this.getProducts();
      this.getServices();
      this.getStoresByRetailer();
      this.getPrivilegeCategories();
      this.getRewardCategories(this.form.rewardType?.code);
      this.getSubBundles();
    },
    getValidFieldsForVoucherType(voucherCode) {
      if (voucherCode === "MEMBERSHIP") {
        return ["voucherThumbnailImage", "rewardInformation", "conditions"];
      } else if (voucherCode === "REFERRAL_COUPON") {
        return ["voucherThumbnailImage", "voucherInformation", "rewardInformation", "conditions"];
      } else if (voucherCode === "PROMOTION") {
        return [
          "voucherTypeCode",
          "categorySelected",
          "rewardInformation",
          "conditions",
        ];
      } else if (voucherCode === "YEAREND") {
        const fields = [
          "pickupStores",
          "yearendSelected",
          "redeem",
          "point",
          "productVariances",
          "bundle",
          "quota",
          "privilegeThumbnailImage",
          "voucherThumbnailImage",
          "detailImages",
          "isAllowDelivery",
          "conditions",
        ];
        if (this.form.productType !== ProductTypeOption.ProductBundle) {
          fields.push("voucherInformation", "rewardInformation");
        }
        return fields;
      } else if (voucherCode === "CATALOG") {
        const fields = [
          "pickupStores",
          "redeem",
          "point",
          "productVariances",
          "bundle",
          "quota",
          "privilegeThumbnailImage",
          "voucherThumbnailImage",
          "detailImages",
          "isAllowDelivery",
          "conditions",
        ];
        if (this.form.productType !== ProductTypeOption.ProductBundle) {
          fields.push("voucherInformation", "rewardInformation");
        }
        return fields;
      } else if (voucherCode === "SAMPLE_PRODUCT") {
        return [
          "redeem",
          "totalQuota",
          "sampleProduct",
          "voucherThumbnailImage",
          "sampleProductDetail",
          "rewardInformation",
        ];
      } else if (voucherCode === "SUB_BUNDLE") {
        return [
          "pickupStores",
          "privilegeThumbnailImage",
          "voucherThumbnailImage",
          "detailImages",
          "isAllowDelivery",
          "voucherInformation",
          "rewardInformation",
          "conditions",
        ];
      }
    },
    isFieldShown(fieldName) {
      const array = this.getValidFieldsForVoucherType(
        this.form.voucherSelected?.code
      );
      if (array?.includes(fieldName)) {
        return true;
      }
    },
    goToDeliveryLabel() {
      this.$router.push({
        path: "/deliveryLabelsForSampleProducts",
        query: { brandCode: this.brandSelected.id, sampleProductId: this.id },
      });
    },
    copyLink() {
      navigator.clipboard.writeText(this.accessLink);
      this.copyText = "copied!";
    },
    changeVoucherType() {
      let packageOption = this.rewardTypeOptions.find(
        (option) => option.code === "PACKAGES"
      );

      if (this.form.voucherSelected?.code === "PROMOTION") {
        delete packageOption.$isDisabled;
      } else {
        packageOption.$isDisabled = true;
        if (this.form.rewardType?.code === "PACKAGES") {
          this.form.rewardType = null;
          this.form.rewardCategories = [];
          this.getRewardCategories(this.form.rewardType?.code);
        }
      }
    },
  },
  watch: {
    multiple(newValue) {
      if (newValue) {
        this.value = this.value ? [this.value] : [];
      } else {
        this.value = this.value[0];
      }
    },
    "form.booking"(newValue) {
      if (!newValue) {
        this.serviceSelected = null;
      }
    },
    "form.topSpenderCampaign"(newValue) {
      if (!newValue) {
        this.form.campaignPurchaseCalculationStartDate = null;
        this.form.campaignPurchaseCalculationEndDate = null;
        this.form.campaignMinimumSpending = null;
        this.form.campaignBanner = null;
        this.form.campaignDetailTh = null;
        this.form.campaignDetailEn = null;
        this.previewCampaignBannerUrl = null;
        this.campaignBannerFile = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.label-title {
  font-weight: 900;
}

.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}

.btn-label:hover {
  color: white;
}

.text-error {
  color: red;
  font-size: 12px;
}

.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}

.btn-add-variance:disabled {
  color: #222;
  border-color: transparent;
  background-color: #ddd;
}

.accessLink {
  font-size: 14px;
  font-weight: bold;
}

.information-title-wrapper {
  background-color: #2a2a2e;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.information-title {
  font-weight: 600;
  font-size: 17px;
  padding: 14px;
  color: #dcdcdc;
}

.information-group {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px, rgba(0, 0, 0, 0.22) 0 2px 2px;
}
</style>
